export default __webpack_public_path__ + "static/media/marking--discrete--arrow--right.0c25ddcb.png";